import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelRadio as _vModelRadio, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51bdae65"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_mismatched_pim_sku",
  ref: "mismatchedPimSkuRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-770px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_mismatched_pim_sku_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1))
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body px-17 py-9" }
const _hoisted_11 = { class: "pt-7" }
const _hoisted_12 = { class: "d-flex gap-3 mb-7" }
const _hoisted_13 = { class: "flex-1 form-group" }
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = { class: "flex-1 form-group" }
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-label fw-bold opacity-0" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_21 = { class: "d-flex flex-column gap-4" }
const _hoisted_22 = { class: "w-100 d-flex flex-column gap-8 lh-sm" }
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "dataTables_empty" }
const _hoisted_29 = { class: "modal-footer align-items-center justify-content-between" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_32 = { class: "svg-icon svg-icon-2" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_35 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_empty_query = _resolveComponent("empty-query")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("h2", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                    _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.props.scanNumber), 1)
                  ])
                ]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("order.brand")), 1),
                    _createVNode(_component_el_form_item, { prop: "brand" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.brand,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.brand) = $event)),
                          filterable: "",
                          clearable: "",
                          "remote-show-suffix": "",
                          remote: "",
                          "remote-method": _ctx.searchBrandSourceItems,
                          loading: _ctx.formData.brandLoading,
                          placeholder: _ctx.t('common.plsSelect'),
                          disabled: _ctx.formData.itemsLoading
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.brandOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value,
                                disabled: _ctx.formData.itemsLoading
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "remote-method", "loading", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("order.nameOrArticleNumber")) + ":", 1),
                    _createVNode(_component_el_form_item, { prop: "search" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.search,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.search) = $event)),
                          modelModifiers: { trim: true },
                          type: "text",
                          clearable: "",
                          placeholder: _ctx.t('common.plsEnter'),
                          disabled: _ctx.formData.itemsLoading
                        }, null, 8, ["modelValue", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("order.brand")) + ":", 1),
                    _createVNode(_component_el_form_item, { prop: "brandOptions" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: 
                        _ctx.loading ||
                        _ctx.formData.itemsLoading ||
                        _ctx.formData.brand === '' ||
                        _ctx.formData.search === ''
                      ,
                          class: "btn btn-primary",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getShowInfo && _ctx.getShowInfo(...args)))
                        }, [
                          _withDirectives(_createElementVNode("span", null, [
                            _hoisted_20,
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                          ], 512), [
                            [_vShow, _ctx.loading || _ctx.formData.itemsLoading]
                          ]),
                          _withDirectives(_createElementVNode("span", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("common.search")), 1)
                          ], 512), [
                            [_vShow, !_ctx.loading && !_ctx.formData.itemsLoading]
                          ])
                        ], 8, _hoisted_19)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _withDirectives(_createVNode(_component_el_form_item, { prop: "items" }, null, 512), [
                    [_vShow, 0]
                  ]),
                  _withDirectives(_createVNode(_component_el_form_item, { prop: "itemsLoading" }, null, 512), [
                    [_vShow, 0]
                  ]),
                  _withDirectives(_createVNode(_component_el_form_item, { prop: "brandLoading" }, null, 512), [
                    [_vShow, 0]
                  ]),
                  _createVNode(_component_el_form_item, { prop: "radio" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("label", {
                            class: "d-flex align-items-center cursor-pointer",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_product_info, {
                                gallery: item.gallery,
                                name: item.name,
                                name_en: item.name_en,
                                source_link: item.source_link,
                                brand_id: item.__show.brand_id
                              }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_sku_info, {
                                brand_article_no: item.brand_article_no,
                                color: item.original_color,
                                size: item.__show.size,
                                product_identifier_id: item.product_identifier_id
                              }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("span", _hoisted_26, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "mismatchedPimSku",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.radio) = $event)),
                                  value: item
                                }, null, 8, _hoisted_27), [
                                  [_vModelRadio, _ctx.formData.radio]
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_empty_query)
                      ], 512), [
                        [_vShow, _ctx.formData.items.length === 0]
                      ])
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, _ctx.formData.itemsLoading]
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.loading,
                class: "btn btn-lg btn-light",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _withDirectives(_createElementVNode("span", null, [
                  _hoisted_31,
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                ], 512), [
                  [_vShow, _ctx.loading]
                ]),
                _withDirectives(_createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_32, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.back")), 1)
                ], 512), [
                  [_vShow, !_ctx.loading]
                ])
              ], 8, _hoisted_30),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.loading || _ctx.formData.itemsLoading || _ctx.isDisabledSubmit,
                class: "btn btn-lg btn-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _withDirectives(_createElementVNode("span", null, [
                  _hoisted_34,
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                ], 512), [
                  [_vShow, _ctx.loading]
                ]),
                _withDirectives(_createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_35, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.confirm")), 1)
                ], 512), [
                  [_vShow, !_ctx.loading]
                ])
              ], 8, _hoisted_33)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}